import { writable } from 'svelte/store';
import { api_url, auth_endpoint, client_id, redirect_uri } from './config.js';

const authorized = writable(false);
const token_regex = /[\w-_]+\.[\w-_](?:\.[\w_-])?/;

//first tries to use code, then get token from localstore, then use refresh token
//returns token on success, false on fail
const authorize = async () => {
  let access_token = await use_code();
  if (access_token) return authorized.set(access_token);
  let [tk, rtk] = check_localstore();
  if (tk && await access_token_is_valid(tk)) return authorized.set(tk);
  else if (rtk) {
    let new_token = await refresh();
    if (new_token) return authorized.set(new_token);
  }
  authorized.set(false);
}

//attempts to extract "code" query param from URL and exchange the code for tokens.
//sets tokens in localstorage
const use_code = async () => {
  let here = window.location.search.slice(1);
  let m = new Map(here.split("&").map(v => v.split("=")));
  let code = m.get('code');
  if (!code) return false;
  //remove code query param from URL
  let new_url = window.location.pathname + (m.size > 1 ? [...m].reduce( ({search, length}, [key, value]) => {
    if (key === "code") return { search, length };
    length++;
    if (length !== 0) search += "&"
    search += `${key}=${value}`;
    return { search, length };
  }, {search:"?", length: 0}).search : "");
  window.history.pushState(null, null, new_url);

  const url = `${auth_endpoint}/oauth2/token?grant_type=authorization_code&client_id=${client_id}&redirect_uri=${redirect_uri}&code=${code}`
  let auth_response = await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    }
  })
  console.log(auth_response);
  if (!auth_response.ok) return false;
  let { id_token, access_token, refresh_token } = await auth_response.json();
  localStorage.setItem('tk', access_token);
  localStorage.setItem('rtk', refresh_token);
  return access_token;
}

const check_localstore = () => {
  let tk = localStorage.getItem('tk');
  let rtk = localStorage.getItem('rtk');
  return [token_regex.test(tk) && tk, token_regex.test(rtk) && rtk];
}

//makes a GET request to the backend. Since GET requests are not supported,
//a 400 indicates a valid token, and a 401 indicates invalid token
const access_token_is_valid = async access_token => {
  let response = await fetch(api_url, {
    headers: {
      Authorization: access_token
    }
  });
  ///response 400 to GET request indicates authorized request since it's not a 401;
  return response.status === 400;
}

//attempts to find refresh token in localstore and use it to refresh tk&rtk
const refresh = async () => {
  let refresh_token = localStorage.getItem('rtk');
  if (!refresh_token || !token_regex.test(refresh_token)) return false;
  const endpoint = `${auth_endpoint}/token?grant_type=refresh_token&client_id=${client_id}&refresh_token=${refresh_token}`;
  const refresh_response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    }
  });
  if (!refresh_response.ok) return false;
  const { access_token: tk } = await refresh_response.json();
  localStorage.setItem('tk', tk);
  return tk;
}

export { authorize, authorized };
